import { ModalsConfig } from '@improver/components/modals';

export const V4_COMAPNY_MODAL_CONFIG: ModalsConfig = {
  defaultTranslations: {
    standardFooter: {
      cancel: 'APP_COMMON_MODAL_BUTTON_CANCEL',
      submit: 'APP_COMMON_MODAL_BUTTON_CONFIRM',
    },
  },
};
